const PageIntegrationsAppV2 = () => import('./IntegrationsAppV2');

export default {
  name: 'integrations-app-v2',
  path: 'app/:id?',
  params: {
    id: null,
  },
  component: PageIntegrationsAppV2,
  meta: {
    title: 'Configurando a instalação',
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/routes.js